export const getAriaProps = (props) => {
    return Object.keys(props).reduce((acc, key) => {
        if (key.startsWith('aria-')) {
            acc[key] = props[key];
        }
        return acc;
    }, {});
};
//# sourceMappingURL=getAriaProps.js.map